import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toDateFormatComma } from '~/shared/utils/date'
import { toCroppedImage } from '~/shared/utils/image'
import type { ResearchDemandCardDirection } from './types'

const DEFAULT_DIRECTION_COLOR = '#9dcfff'

export default class ResearchDemandCard extends BaseModel {
  static override constructorName = 'ResearchDemandCard'

  id: number = 0
  name: string = ''
  slug: string = ''
  url: string = ''
  'company_name': string = ''
  'company_image': string = ''
  'main_image': string = ''
  'short_description': string = ''
  direction: ResearchDemandCardDirection = { id: '', name: '', color: '' }
  'date_publication': string = ''
  'research_deadline': string = ''
  'likes_count': number = 0
  'views_count': number = 0

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data)

    this.main_image = toCroppedImage(this.main_image)
    this.company_image = toCroppedImage(this.company_image)

    if (this.date_publication) {
      this.date_publication = toDateFormatComma(this.date_publication)
    }

    if (this.research_deadline) {
      this.research_deadline = toDateFormatComma(this.research_deadline)
    }
  }

  get tagColor(): string {
    return this.direction?.color || DEFAULT_DIRECTION_COLOR
  }
}

registerModel(ResearchDemandCard)
